import Web3 from "web3";
import React from "react";
import Switch from "react-switch";
import {
  Card,
  CardBody,
  Col,
  Row,
  Button,
  Input,
  Label,
  FormGroup,
  Form,
  InputGroupText,
  InputGroup,
} from "reactstrap";
import Page from "../../components/Page";
import PageSpinner from "../../components/PageSpinner";
import NotificationSystem from "react-notification-system";
import { NOTIFICATION_SYSTEM_STYLE } from "../../utils/constants";
import { contractAddress } from "./Membership";
import membershipABI from "../../contracts_abi/membership.json";

class MembershipEdit extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      showLoader: false,
      membership: props.membership || {},
    };
  }

  createMembership = async (event) => {
    try {
      event.preventDefault();
      this.setState({ showLoader: true });
      const account = localStorage.getItem('walletAddress');
      const web3 = new Web3(Web3.givenProvider);
      const myContract = await new web3.eth.Contract(membershipABI, contractAddress);
      const membership = await myContract.methods
        .createMembership(
          this.state.membership.membershipName,
          this.state.membership.freeMembership ? 0 : this.state.membership.membershipPrice,
          this.state.membership.unlimitedDuration ? 0 : this.state.membership.membershipDuration,
          this.state.membership.unlimitedCount ? 0 : this.state.membership.membershipCount,
          this.state.membership.unlimitedCount || false,
          this.state.membership.unlimitedDuration || false,
          this.state.membership.freeMembership || false
        )
        .send({
          from: account
        });
      console.log({ membership });
      let response = { message: 'ok' };
      if (response) {
        this.setState({ showLoader: false });
        this.notificationSystem.addNotification({
          message: response.message,
          level: "success",
        });
        this.closeEditPage(true);
      }
    } catch (error) {
      this.setState({ showLoader: false });
      this.notificationSystem.addNotification({
        message: error.message,
        level: "error",
      });
    }
  };

  updateMembership = async (event) => {
    event.preventDefault();
    try {
      // if (response) {
      //   this.setState({ showLoader: false });
      //   this.notificationSystem.addNotification({
      //     message: response.message,
      //     level: "success",
      //   });
      //   this.closeEditPage(true);
      // }
    } catch (error) {
      this.setState({ showLoader: false });
      this.notificationSystem.addNotification({
        message: error.message,
        level: "error",
      });
    }
  };

  closeEditPage = (value) => {
    this.props.closeMembershipEditPage({ refreshList: value });
  };

  render() {
    return (
      <div>
        <PageSpinner showLoader={this.state.showLoader} />
        <Page
          title={this.props.editMembershipKey ? "Edit Membership" : "Add Membership"}
          breadcrumbs={[
            {
              name: this.props.editMembershipKey
                ? "Edit Membership"
                : "Add Membership",
              active: true,
            },
          ]}
        >
          <Row>
            <Col>
              <Card className="mb-3">
                <CardBody>
                  <Form
                    onSubmit={
                      this.props.editMembershipKey
                        ? this.updateMembership
                        : this.createMembership
                    }
                  >
                    <Row>
                      <Col xl={6} lg={12} md={12}>
                        <FormGroup>
                          <Label for="name">Name</Label>
                          <Input
                            type="text"
                            name="name"
                            required
                            value={this.state.membership.membershipName || ""}
                            placeholder="Membership Name"
                            autoComplete="off"
                            onChange={(event) =>
                              this.setState({
                                membership: {
                                  ...this.state.membership,
                                  membershipName: event.target.value,
                                },
                              })
                            }
                          />
                        </FormGroup>
                      </Col>
                    </Row>
                    <Row>
                      <Col xl={6} lg={12} md={12}>
                        <FormGroup>
                          <Label for="membershipDuration">Memberships duration (days):</Label>
                          <label
                            htmlFor="membershipDuration"
                            style={{
                              float: 'right',
                              display: 'flex',
                              justifyContent: 'center',
                              alignItems: 'center',
                            }}
                          >
                            <span style={{ marginRight: '10px' }}>Unlimited</span>
                            <Switch
                              checked={this.state.membership.unlimitedDuration}
                              onChange={(event) =>
                                this.setState({
                                  membership: {
                                    ...this.state.membership,
                                    unlimitedDuration: event,
                                  },
                                })
                              }
                              onColor="#A4B8C7"
                              onHandleColor="#17517b"
                              handleDiameter={25}
                              uncheckedIcon={false}
                              checkedIcon={false}
                              boxShadow="0px 1px 5px rgba(0, 0, 0, 0.6)"
                              activeBoxShadow="0px 0px 1px 10px rgba(0, 0, 0, 0.2)"
                              height={20}
                              width={48}
                              className="react-switch"
                              id="membershipDuration"
                            />
                          </label>
                          <Input
                            type="number"
                            name="membershipDuration"
                            required
                            value={this.state.membership.membershipDuration || ""}
                            placeholder="Enter Duration"
                            autoComplete="off"
                            onChange={(event) =>
                              this.setState({
                                membership: {
                                  ...this.state.membership,
                                  membershipDuration: event.target.value,
                                },
                              })
                            }
                            disabled={this.state.membership.unlimitedDuration}
                          />
                        </FormGroup>
                      </Col>
                    </Row>
                    <Row>
                      <Col xl={6} lg={12} md={12}>
                        <FormGroup>
                          <Label for="membershipCount">Number of memberships for sale:</Label>
                          <label
                            htmlFor="membershipCount"
                            style={{
                              float: 'right',
                              display: 'flex',
                              justifyContent: 'center',
                              alignItems: 'center',
                            }}
                          >
                            <span style={{ marginRight: '10px' }}>Unlimited</span>
                            <Switch
                              checked={this.state.membership.unlimitedCount}
                              onChange={(event) =>
                                this.setState({
                                  membership: {
                                    ...this.state.membership,
                                    unlimitedCount: event,
                                  },
                                })
                              }
                              onColor="#A4B8C7"
                              onHandleColor="#17517b"
                              handleDiameter={25}
                              uncheckedIcon={false}
                              checkedIcon={false}
                              boxShadow="0px 1px 5px rgba(0, 0, 0, 0.6)"
                              activeBoxShadow="0px 0px 1px 10px rgba(0, 0, 0, 0.2)"
                              height={20}
                              width={48}
                              className="react-switch"
                              id="membershipCount"
                            />
                          </label>
                          <Input
                            type="number"
                            name="membershipCount"
                            required
                            value={this.state.membership.membershipCount || ""}
                            placeholder="Enter Quantity"
                            autoComplete="off"
                            onChange={(event) =>
                              this.setState({
                                membership: {
                                  ...this.state.membership,
                                  membershipCount: event.target.value,
                                },
                              })
                            }
                            disabled={this.state.membership.unlimitedCount}
                          />
                        </FormGroup>
                      </Col>
                    </Row>
                    <Row>
                      <Col xl={6} lg={12} md={12}>
                        <FormGroup>
                          <Label for="membershipPrice">Currency & Price:</Label>
                          <label
                            htmlFor="membershipPrice"
                            style={{
                              float: 'right',
                              display: 'flex',
                              justifyContent: 'center',
                              alignItems: 'center',
                            }}
                          >
                            <span style={{ marginRight: '10px' }}>Free</span>
                            <Switch
                              checked={this.state.membership.freeMembership}
                              onChange={(event) =>
                                this.setState({
                                  membership: {
                                    ...this.state.membership,
                                    freeMembership: event,
                                  },
                                })
                              }
                              onColor="#A4B8C7"
                              onHandleColor="#17517b"
                              handleDiameter={25}
                              uncheckedIcon={false}
                              checkedIcon={false}
                              boxShadow="0px 1px 5px rgba(0, 0, 0, 0.6)"
                              activeBoxShadow="0px 0px 1px 10px rgba(0, 0, 0, 0.2)"
                              height={20}
                              width={48}
                              className="react-switch"
                              id="membershipPrice"
                            />
                          </label>
                          <InputGroup>
                            <InputGroupText
                              style={{
                                display: 'flex',
                                justifyContent: 'center',
                                alignItems: 'center',
                                background: '#ffff',
                                marginRight: '10px',
                              }}
                            >
                              <img
                                width="30px"
                                height="auto"
                                src="https://image.zocial.io/zencafe/polygon_matic.png"
                              />
                              MATIC
                            </InputGroupText>
                            <Input
                              type="number"
                              name="membershipPrice"
                              required
                              value={this.state.membership.membershipPrice || ""}
                              placeholder="Enter Quantity"
                              autoComplete="off"
                              onChange={(event) =>
                                this.setState({
                                  membership: {
                                    ...this.state.membership,
                                    membershipPrice: event.target.value,
                                  },
                                })
                              }
                              disabled={this.state.membership.freeMembership}
                            />
                          </InputGroup>
                        </FormGroup>
                      </Col>
                    </Row>
                    <Row>
                      <Col xl={6} lg={12} md={12}>
                        {this.props.editMembershipKey ? (
                          <Button color="primary" type="submit">
                            Update
                          </Button>
                        ) : (
                          <Button color="primary" type="submit">
                            Create
                          </Button>
                        )}
                        <Button
                          style={{ float: 'right' }}
                          color="secondary"
                          onClick={(event) => {
                            this.closeEditPage(false);
                          }}
                        >
                          Cancel
                        </Button>
                      </Col>
                    </Row>
                  </Form>
                </CardBody>
              </Card>
            </Col>
          </Row>
          <NotificationSystem
            dismissible={false}
            ref={(notificationSystem) =>
              (this.notificationSystem = notificationSystem)
            }
            style={NOTIFICATION_SYSTEM_STYLE}
          />
        </Page>
      </div>
    );
  }
}
export default MembershipEdit;
